<template>
	<section id="tipos">
		<Notification ref="notif" :closed="true" corner="bottom-right" />
		<container title="Tipos de Objeto" textButton="ADICIONAR" :pathName="{ name: 'tiposCreate' }">
			<load-content v-if="loadContent && tiposList.length === 0" />
			<div class="table-wrapper" v-if="tiposList.length > 0 && !loadContent">
				<div class="table">
					<table>
							<thead>
								<tr>
									<th class="codigo">Cod.</th>
									<th class="nome">Tipo do Objeto</th>
									<th>Objetos Cadastrados</th>
									<th>Status</th>
									<th>Ações</th>
								</tr>
							</thead>

							<tbody>
								<tr class="fields" v-for="tipos in tiposList" :key="tipos.id">
									<td class="codigo">{{ tipos.codigo }}</td>
									<td class="nome"><span>{{ tipos.nome }}</span></td>
									<td>{{ tipos.totalDeObjetos }}</td>
									<td class="field-status">
										<item-status :status="tipos.flagAtivo"></item-status>
									</td>
									<td>
										<div class="acoes">
											<item-edit class="edit" routerName="tiposEdit" :params="{ id: tipos.id }"></item-edit>
											<router-link class="visualizar acao" :to="{ name: 'tiposDetalhes', params: { id: tipos.id }}">
												<i class="far fa-eye"></i>
											</router-link>
											<button-remove class="delete" :totalObjetos="tipos.totalDeObjetos" :onClick="() => selectTiposHandler(tipos)"></button-remove>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<!-- Modal para confirmação de exclusão de tipo de objeto -->
				<Modal v-show="isModalVisible" @close="() => this.isModalVisible = !this.isModalVisible">
					<template v-slot:body>
						<p class="texto">Deseja remover o Tipo <i>{{ removeItem.nome }}</i>?</p>
					</template>

					<template v-slot:footer>
						<button-action type="button" :onClick="() => deleteTipos(removeItem.id)" class="xs danger" style="margin-right: 10px;">Confirmar</button-action>
						<button-action type="button" :onClick="closeModal" class="xs default">Cancelar</button-action>
					</template>
				</Modal>

				<div v-if="!loadContent && !tiposList.length" class="not-found">
						Não foi encontrado nenhum tipo de objeto :)
				</div>
		</container>
	</section>
</template>

<script>
import ButtonRemove from '@/components/shared/ButtonRemove'
import { tipos } from '@/services/tipos'
import container from '@/components/shared/Container'
import Modal from '@/components/shared/Modal'
import ButtonAction from '@/components/shared/ButtonAction'
import ItemStatus from '@/components/shared/ItemStatus'
import ItemEdit from '@/components/shared/ItemEdit'
import LoadContent from '@/components/shared/LoadContent'

export default {
	name: 'TipoList',
	components: {
		container,
		ButtonRemove,
		Modal,
		ButtonAction,
		ItemStatus,
		ItemEdit,
		LoadContent
	},
	data () {
		return {
			tiposList: [],
			isModalVisible: false,
			removeItem: {},
			loadContent: true
		}
	},
	async created () {
		await tipos.find({})
			.then(res => {
				this.tiposList = res.data
				this.loadContent = false
			})
			.catch(e => {
				this.loadContent = false
			})
		if (this.$route.params.message) {
			window.notificationEM.open('', this.$route.params.message, this.$route.params.alert)
		}
	},
	methods: {
		selectTiposHandler (data) {
			this.isModalVisible = true
			this.removeItem = data
		},
		closeModal () {
			this.isModalVisible = false
		},
		async deleteTipos (id) {
			this.isModalVisible = false
			try {
				await tipos.delete(id)

				// if (tip.status === 200) {
				this.tiposList = this.tiposList.filter(tip => tip.id !== id)
				this.removeItem = {}
				window.notificationEM.open('', 'Tipo removido com sucesso!', 'success')
			} catch (e) {
				window.notificationEM.open('', e.response.data.msg, 'error')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
 #tipos{
	.table-wrapper{

		.table{
			display:flex;
			padding: 5px 0px 5px;

			th:last-child {
				display: flex;
				justify-content: center;
			}

			td {
				vertical-align: middle;
			}

			th.codigo, td.codigo {
				width: 60px;
				text-align: left;
			}

			th.nome, td.nome {
				text-align: left;
			}

			td:last-child {
				display: flex;
				justify-content: center;
			}

			.acoes {
				display: flex;

				.visualizar {
					background: #00243e 0% 0% no-repeat padding-box;
					border-radius: 5px;
					width: 28px;
					height: 28px;
					opacity: 1;
					color: #fff;
					display: flex;
					align-items: center;
					justify-content: center;
					.fa-eye:before {
						content: "\f06e";
						position: relative;
					}
					margin-right: 10px;
				}
				.edit {
					margin-right: 10px;
				}
			}

			.paginacao{
				width:100%;
			}
		}
	}

	.not-found {
		margin-top: 50px;
		color: #000;
		text-align: center;
	}
}
</style>
